<template>
  <div class="app-calendar overflow-hidden border">
    <div class="no-gutters">

      <!-- Calendar -->
      <div class="col position-relative">
        <div class="card shadow-none border-0 mb-0 rounded-0">
          <div class="card-body pb-0 calendar-campaign-manager">
            <full-calendar
              ref="refCalendar"
              :options="calendarOptions"
              :key="key_calendar"
            />
          </div>
        </div>
      </div>
    </div>

    <sidebar-content
      v-if="Object.keys(event_detail).length !== 0"
      :show_side="show_side"
      :content_dad="event_detail"
      :campaign_influencer="campaign_influencer"
      :campaign_uuid="campaign_uuid"
      @updateFromSidebar="updateFromSidebar"
      :key="change_sidebar"
      class="open-sidebar-contents"
    />
    <b-modal id="detail-event" body-class="p-0" centered hide-header hide-footer>
      <detail-event :event="event_detail"/>
    </b-modal>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import service from "@/services/campaign"
import manage_campaign from '@/services/manage_campaign'
import {
  BModal,
} from 'bootstrap-vue'
import DetailEvent from './DetailEvent'
import esLocale from '@fullcalendar/core/locales/es';
import sidebarContent from '@/views/components/campaign/sidebarContent';
import { isUrl, getAssetUrl, verifyAsset } from '@/libs/utils/urls'
import { getFormat, decimalFixed } from '@/libs/utils/formats';
import { hasPermission } from '@/libs/utils/user';
import filtersDropdown from '@/views/components/brandme-ai/dropdowns/filtersDropdown.vue'
import Vue from 'vue'

export default {
  name: 'CalendarInfluencers',
  components: {
    FullCalendar,
    BModal,
    DetailEvent,
    sidebarContent,
  },
  data() {
    return {
      verifyAsset,
      hasPermission,
      decimalFixed,
      getFormat,
      getAssetUrl,
      isUrl,
      show_side: false,
      campaign_uuid: this.$route.params.uuid,
      campaign_influencer: '',
      change_sidebar: false,
      influencers_key: false,
      key_calendar: false,
      contents: [],
      events: [],
      event_detail: {},
      variant_influencers: [
        {type: 'top-influencer-celebrity', variant: 'danger'},
        {type: 'macroinfluencer', variant: 'primary'},
        {type: 'microinfluencer', variant: 'warning'},
        {type: 'nanoinfluencer', variant: 'success'},
        {type: 'top-celebrity', variant: 'info'},
      ],
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin],
        initialView: 'dayGridMonth',
        headerToolbar: {
          start: 'prev,next, title',
          center: '',
          end: 'dayGridMonth,timeGridWeek,timeGridDay,listMonth',
        },
        editable: true,
        eventResizableFromStart: false,
        dragScroll: true,
        dayMaxEvents: 100,
        navLinks: true,
        locale: esLocale,
        eventClassNames: this.getEventClass,
        eventDrop: this.handleEventDrop,
        eventClick: this.handleEventCLick,
        rerenderDelay: 350,
        events: [],
        eventDidMount: (info) => {
          if (info.view.type !== 'listMonth') {
            const container = info.el.querySelector('.fc-event-title-container')
            const data = this.formatEventData(info.event)

            const div = document.createElement('div')
            div.classList.add('fc-sticky')

            const rowTop = document.createElement('div')
            rowTop.classList.add('d-flex', 'align-items-center', 'gap-1', 'overflow-hidden', 'mb-1')

            const img = document.createElement('img')
            img.setAttribute('src', data.extendedProps.profile_url)
            img.classList.add('social-network-calendar', 'd-none', 'd-sm-block', 'rounded-circle')
            img.style.width = '20px'
            img.style.height = '20px'

            const name = document.createElement('span')
            name.textContent = data.extendedProps.name
            name.classList.add('fw-bold')
            name.style.maxWidth = '100px'

            rowTop.appendChild(img)
            rowTop.appendChild(name)

            const description = document.createElement('div')
            description.textContent = data.extendedProps.description
            description.classList.add('small', 'overflow-hidden')
            description.style.maxWidth = '100px'

            // Agregar todo al div principal
            div.appendChild(rowTop)
            div.appendChild(description)
            container.appendChild(div)
            container.innerHTML = ''
            container.appendChild(div)
          }
        }

      },
      filter_category: '',
      filter_networks: [],
      networks_avaibles: [
        { value: 'instagram', text: 'Instagram' },
        { value: 'youtube', text: 'YouTube' },
        { value: 'tiktok', text: 'TikTok' },
        { value: 'twitter', text: 'Twitter' },
        { value: 'twitch', text: 'Twitch' },
        { value: 'blog', text: 'Blog' },
        { value: 'snapchat', text: 'Snapchat' },
        { value: 'linkedin', text: 'LinkedIn' },
        { value: 'facebook', text: 'Facebook' },
        { value: 'pinterest', text: 'Pinterest' },
        { value: 'spotify', text: 'Spotify' },
      ],
    }
  },
  created() {
    this.getContents();
  },
  async mounted() {
    this.vue_select = (await import('vue-select')).default;
    this.$nextTick(() => {
      const toolbarCenter = this.$el.querySelector('.fc-toolbar .fc-toolbar-chunk:nth-child(2)'); // center

      if (toolbarCenter) {
        const customDiv = document.createElement('div');
        customDiv.id = 'custom-filters';
        toolbarCenter.appendChild(customDiv);

        const Constructor = this.$options.components.FiltersDropdown || Vue.extend(filtersDropdown);
        const instance = new Constructor({
          parent: this,
          propsData: {
            networks_avaibles: this.networks_avaibles,
          }
        });
        instance.$mount('#custom-filters');
        instance.$on('filters-changed', ({ query, type, networks }) => {
          this.query = query;
          this.filter_category = type === 'all' ? '' : type;
          this.filter_networks = networks || [];
          this.getContents();
        });
      }
    });
  },
  methods: {
    getContents() {
      const filters = {
        statuses: ['content_published'],
        category: this.filter_category,
        networks: this.filter_networks,
        query: this.query || '',
      };
      service.getContentsManage(this.$route.params.uuid, 1, 100, filters)
        .then(response => {
          this.contents = response.results
          const events = this.formatEvents()
          this.calendarOptions.events = events
          this.calendarOptions.locale = this.$i18n.locale === 'es' ? esLocale : this.$i18n.locale
          this.events = events
          this.loading_search = false;
          this.influencers_key = !this.influencers_key
          const self = this
          setTimeout(() => {
            if (self.$refs.refCalendar) {
              self.$refs.refCalendar.getApi().changeView('timeGridDay')
              self.$refs.refCalendar.getApi().changeView('dayGridMonth')
            }
          }, 200)
        })
    },
    updateFromSidebar(data) {
      this.show_side = false;
      this.event_detail.status = data.status;
      this.event_detail.url_info = data.url_info;
      this.event_detail.number_of_impressions = data.number_of_impressions;
      this.event_detail.updated_at = data.updated_at;
      this.event_detail.published_date = data.published_date
      this.event_detail.number_of_comments = data.number_of_comments
      this.event_detail.number_of_likes = data.number_of_likes
      this.event_detail.number_of_shares = data.number_of_shares
      this.change_sidebar = !this.change_sidebar;
      const new_events = this.formatEvents();
      this.calendarOptions.events = new_events;
      this.key_calendar = !this.key_calendar;
    },
    formatEventData(data) {
      const {
        id,
        title,
        start,
        end,
        allDay,
        extendedProps: {
          variant,
          type_influencer,
          network,
          username,
          name,
          profile_url,
          followers,
          is_verified,
          link_content,
          description
        }
      } = data

      return {
        id,
        title,
        start,
        end,
        extendedProps: {
          variant,
          type_influencer,
          network,
          username,
          name,
          profile_url,
          followers,
          is_verified,
          link_content,
          description
        },
        allDay,
      }
    },
    handleEventDrop ({event: clickedEvent}) {
      if (this.disabledUpdateCampaign()) return;

      const data = this.formatEventData(clickedEvent)
      const new_date = new Date(data.start).toISOString().split('T')[0]

      const formData = new FormData()
      formData.append('published_date', new_date)

      manage_campaign.updateContent(this.$route.params.uuid, data.id, formData)
        .then(() => {
        })
    },
    handleEventCLick({event: clickedEvent}) {
      this.event_detail = this.formatSidebar(clickedEvent);
      this.show_side = true;
      this.change_sidebar = !this.change_sidebar;
    },
    getEventClass({event: calendarEvent}) {
      const data = this.formatEventData(calendarEvent)

      return [`bg-light-${data.extendedProps.variant}`,]
    },
    formatEvents() {
      const events = [];

      this.contents.forEach(con => {
        if (con.published_date) {
          const influencer = con.influencer;
          const variant = this.getVariant(influencer);
          const date_end = new Date(con.published_date);
          date_end.setDate(date_end.getDate() + 2);

          const obj = {
            id: con.uuid,
            title: '',
            start: con.published_date,
            end: date_end,
            allDay: true,
            icon: '',
            extendedProps: {
              con,
              variant,
              type_influencer: influencer.calculate_category,
              network: influencer.network.toLowerCase(),
              username: influencer.username,
              name: influencer.name,
              image_url: influencer.image_url,
              engagement_rate: influencer.engagement_rate,
              file_for_profile: influencer.file_for_profile,
              profile_url: !influencer.file_for_profile ? verifyAsset(influencer.file_for_profile) : verifyAsset(influencer.image_url),
              followers: influencer.followers,
              is_verified: influencer.is_verified,
              link_content: con.url_info ? con.url_info : (con.image_content ? con.image_content : null),
              description:  con.url_info ? this.$t('campaigns.onePublsihed') : (con.image_content ? this.$t('campaigns.onePublsihed') : this.$t('campaigns.withoutPublish'))
            }
          }
          events.push(obj)
        }
      })
      return events
    },
    formatSidebar(clickedEvent) {
      const data = clickedEvent._def.extendedProps
      const content = clickedEvent._def.extendedProps.con;
      this.campaign_influencer = content.campaing_influencer;
      content.username = data.username;
      content.category = data.type_influencer;
      content.image_url = data.image_url;
      content.profile_url = data.profile_url;
      content.followers = getFormat(data.followers);
      content.engagement = decimalFixed(data.engagement_rate, 2),
      content.file_for_profile = data.file_for_profile;
      content.network_influencer = data.network.toLowerCase();
      content.name = data.name;
      content.is_verified = data.is_verified
      return content
    },
    getVariant(influencer) {
      const variant = this.variant_influencers.find(item => item.type === influencer.calculate_category)

      if (variant) return variant.variant
      else 'secondary'
    },
    filterEvents(filters) {
      const events = this.events.filter(event => {
        return filters.indexOf(event.extendedProps.type_influencer) >= 0 || filters.indexOf(event.title) >= 0
      })

      this.calendarOptions.events = events
    },
    disabledUpdateCampaign() {
      return !hasPermission('change_campaign')
    },
  },
  watch: {
    '$i18n.locale'() {
      this.calendarOptions.locale = this.$i18n.locale === 'es' ? esLocale : this.$i18n.locale
      this.key_calendar = !this.key_calendar
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
  .social-network-calendar {
    width: 1.6em;
    border-radius: 50%;
    margin-right: 10px;
  }

  .padding-4 {
    left: 10%;
    padding: 4px;
  }
  .calendar-campaign-manager .fc-header-toolbar .fc-toolbar-chunk:nth-child(1),
  .calendar-campaign-manager .fc-header-toolbar .fc-toolbar-chunk:nth-child(2) {
    margin-right: 10px;
  }

  .calendar-campaign-manager .fc-header-toolbar .fc-toolbar-chunk:last-child {
    margin-top: 20px;
  }


</style>
